import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Header } from "../components";
import Modal from "../components/Modal";
// import { useStateContext } from "../contexts/ContextProvider";
import { employeesGrid } from "../data/dummy";

import { BsPencilSquare, BsTrash2 } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { IoIosPersonAdd } from "react-icons/io";
import { toast, ToastContainer } from "react-toastify";
import { bureau } from "../components/Fields";
import { useStateContext } from "../contexts/ContextProvider";

import Modal1 from "../components/Modal1";

import UsagersCard from "../components/UsagersCard";
import { useLazyGetFieldsByFormQuery } from "../redux/formService";
import { useLazyGetParamsQuery } from "../redux/paramService";
import {
  useDeleteRedevableMutation,
  useLazyGetRedevablesQuery,
  useLazySearchRedevablesQuery,
  usePostRedevableMutation,
  useUpdateRedevableMutation,
} from "../redux/redevableService";
import {
  useLazyGetRedevanceAnalyseByIdQuery,
  usePostRedevanceMutation,
} from "../redux/redevanceService";
import { filterDataByDate } from "../utils";
import Pagination from "./../components/Pagination";
import { useNavigate } from "react-router-dom";

const Employees = () => {
  const { currentColor } = useStateContext();
  const [showForm, setShowForm] = useState(false);
  const [showUsager, setShowUsager] = useState(false);
  const [fields, setFields] = useState([]);
  const [selected, setSelected] = useState();
  const [communes, setCommunes] = useState();
  const [villes, setVilles] = useState();
  const [filter, setFilter] = useState("all");
  const [redevances, setRedevances] = useState();
  const [typeData, setTypeData] = useState();

  const [getParams] = useLazyGetParamsQuery();
  const [getFields, { data: fieldsData }] = useLazyGetFieldsByFormQuery();
  const [getRedevables, { data }] = useLazyGetRedevablesQuery();
  const [getRedevancesAnalyseById, { data: redevancesAnalyseData }] =
    useLazyGetRedevanceAnalyseByIdQuery();

  const  [searchRedevable, { data: searchData }] = useLazySearchRedevablesQuery();

  const [postRedevable] = usePostRedevableMutation();
  const [postRedevance] = usePostRedevanceMutation();
  const [updateRedevable] = useUpdateRedevableMutation();
  const [redevanceAnalyseData, setRedevanceAnalyseData] = useState();

  const [deleteUsager, setDeleteUsager] = useState(false);
  const [deleteRedevable] = useDeleteRedevableMutation();
  const [searchTerm, setSearchTerm] = useState("");

  const [fetchedPage, setFetchedPage] = useState({ page: 1, size: 50 });

  const navigate = useNavigate()

  const filteredData = useMemo(
    () => filterDataByDate(data, filter),
    [data, filter]
  );

  let grid;
  const toolbarClick = (args) => {
    if (grid && args.item.id === "Grid_excelexport") {
      grid.showSpinner();
      grid.excelExport();
    }
  };

  const excelQueryCellInfo = (args) => {
    // Exclure la colonne Action de l'export
    if (args.column.headerText === "Action") {
      args.cancel = true;
      return;
    }

    if (args.column.headerText === "Raison social") {
      args.hyperLink = {
        displayText: args.data?.attributes?.name,
      };
    }
    if (args.column.headerText === "Adresse") {
      args.hyperLink = {
        displayText: args.data?.attributes?.quartier?.data?.attributes?.name,
      };
    }
    if (args.column.headerText === "Date d'ajout") {
      args.hyperLink = {
        displayText: new Date(
          args.data?.attributes?.createdAt
        ).toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
      };
    }
  };

  const excelExportComplete = () => {
    grid.hideSpinner();
  };

  const fetchDropdownData = useCallback(async () => {
    const endpoints = ["communes", "villes", "quartiers", "types"];
    const results = await Promise.all(
      endpoints.map((endpoint) =>
        getParams({ endpoint, page: 1, size: 50 }).then((res) =>
          res?.data?.data.map((item) => ({
            label: item.attributes.name,
            value:
              endpoint !== "types"
                ? item?.id
                : { form: item?.attributes?.form?.data?.id, value: item.id },
          }))
        )
      )
    );
    setCommunes(results[0]);
    setVilles(results[1]);
    setTypeData(results[3]); // Charger les types dans typeData
    console.log("results", results);

    let data = {
      endpoint: "bureaus",
      page: 1,
      size: 50,
    };

    getParams(data).then((res) => {
      console.log("params", res);
      const data = res?.data?.data.map((item) => ({
        label: item.attributes.name,
        value: item.id,
      }));
      setFields((prev) =>
        prev.map((field) => {
          if (field.attributes.field_id === "bureau") {
            return {
              ...field,
              attributes: { ...field.attributes, options: data },
            };
          }
          return field;
        })
      );
    });

    if (fieldsData?.data.length > 0) {
      const updatedFields = fieldsData.data.map((field) => {
        if (field.attributes.field_id === "commune") {
          return {
            ...field,
            attributes: { ...field.attributes, options: results[0] },
          };
        }
        if (field.attributes.field_id === "ville") {
          return {
            ...field,
            attributes: { ...field.attributes, options: results[1] },
          };
        }
        if (field.attributes.field_id === "quartier") {
          return {
            ...field,
            attributes: { ...field.attributes, options: results[2] },
          };
        }
        return field;
      });
      setFields(updatedFields); // Mettre à jour les champs avec les options
    }
  }, [fieldsData, getParams]);

  const handleShowModal = useCallback((props) => {
    setSelected(props);
    localStorage.setItem("redevance", JSON.stringify(props));
    setShowForm(true);
  }, []);

  const handleShowUsager = useCallback(
    (props) => {
      let myAnalyse = {}
      getRedevancesAnalyseById(props?.id).then((res) => {
        console.log("redevancesAnalyseData", res);
        myAnalyse = res.data
        setRedevanceAnalyseData(res.data);
      });

      navigate(`/usager/${props?.id}`, {  state: { 
        redevable: {
          id: props?.id,
          ...props?.attributes
        }
        // Retirez 'analyse' pour éviter l'erreur de clonage
      }  })

      setSelected(props?.attributes);
      localStorage.setItem("redevance", JSON.stringify(props));
      setShowUsager(true);
    },
    [getRedevancesAnalyseById]
  );

  const handleDelele = useCallback(
    (props) => {
      console.log("props", props);
      setSelected({ id: props?.id, ...props?.attributes });
      localStorage.setItem("redevance", JSON.stringify(props));
      setDeleteUsager(true);
    },
    [getRedevancesAnalyseById]
  );

  const next = useCallback(() => {
    setFetchedPage((prev) => {
      const nextPage = prev.page + 1;
      getRedevables({ page: nextPage, size: prev.size });
      return { ...prev, page: nextPage };
    });
  }, [getRedevables]);

  const prev = useCallback(() => {
    setFetchedPage((prev) => {
      const prevPage = prev.page > 1 ? prev.page - 1 : 1;
      getRedevables({ page: prevPage, size: prev.size });
      return { ...prev, page: prevPage };
    });
  }, [getRedevables]);

  const getRedevablesByElementsNb = useCallback(
    (elementsNb) => {
      const size = parseInt(elementsNb, 10) || 10; // Convertir en entier ou utiliser 10 par défaut
      setFetchedPage((prev) => {
        const newPage = 1; // Réinitialiser à la première page
        getRedevables({ page: newPage, size });
        return { page: newPage, size };
      });
    },
    [getRedevables]
  );

  const search = useCallback(
    (e) => {
      const value = e?.target?.value;
      setSearchTerm(value);
      if (value.length > 2) {
        searchRedevable({ search: value, page: 1, size: 50 }).then((res) => {
          console.log("searchData", res);
          if (res?.data?.data) {
            getRedevables({ page: 1, size: 50 });
            setFetchedPage({ page: 1, size: 50 });
            toast.success("Recherche réussie");
          } else {
            toast.error("Aucun résultat trouvé");
          }
          if (res?.error) {
            console.error("Erreur lors de la recherche :", res.error);
            toast.error("Erreur lors de la recherche");
          }
          if (res?.data?.data?.length === 0) {
            toast.error("Aucun résultat trouvé");
          }
          if (res?.data?.data?.length > 0) {
            getRedevables({ page: 1, size: 50 });
            setFetchedPage({ page: 1, size: 50 });
            toast.success("Recherche réussie");
          }
        });
      } else {
        getRedevables({ page: 1, size: 50 });
        setFetchedPage({ page: 1, size: 50 });
        toast.error("Veuillez entrer au moins 3 caractères pour la recherche");
      }
    },
    [searchTerm]
  );


  const handleDeleteAction = async () => {
    console.log("delete selected", selected);
    try {
      await deleteRedevable({
        id: selected.id,
        data: {
          publishedAt: null,
        },
      })
        .unwrap()
        .then((res) => {
          console.log("Redevable supprimé avec succès", res);
          if (res?.data) {
            getRedevables({ page: 1, size: 50 });
            setDeleteUsager(false);
            // setDeleteUsager(false);
            toast.success("Redevable supprimé avec succès");
          }
        });
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
      toast.error("Erreur lors de la suppression");

      setDeleteUsager(false);
    }
  };

  const send = async (data) => {
    console.log("data", data);
    console.log("selected", selected);

    const user = localStorage.getItem("auth");
    const userId = user ? JSON.parse(user).user.id : null;

    data.agent = userId;
    data.type = +data.type

    if (data.montant == 0 || (!data.type && !selected)) {
      toast.error(
        "Veuillez choisir un type de redevance et remplir les champs"
      );
      return;
    }

    try {
      if (selected) {
        await updateRedevable({
          id: selected.id,
          data: {
            ...data,
            type: data?.type?.value,
            bureau: data.bureau?.value,
            quartier: data.quartier?.value,
            ville: data.ville?.value,
            commune: data.commune?.value,
          },
        })
          .unwrap()
          .then(() => {
            getRedevables({ page: 1, size: 50 });
            setShowForm(false);
          })
          .catch((error) => {
            console.error("Erreur lors de la mise à jour :", error);
            toast.error("Erreur lors de la mise à jour");
          });
        setShowForm(false);
        toast.success("Redevable modifié avec succès");
        return;
      }
      if (data.type && !selected) {
        const response = await postRedevable({ data });
        console.log("response", response);

        if (!response.data) {
          console.error("Erreur lors de l'envoi :", response.error);
          toast.error("Erreur lors de l'envoi");

          // Vérifier que la structure d'erreur existe avant d'y accéder
          if (response?.error?.data?.error?.details?.errors) {
            response.error.data.error.details.errors.forEach((error) => {
              const fieldTranslations = {
                nina: "NINA",
                rccm: "RCCM",
                email: "Email",
                phone: "Téléphone",
              };

              const fieldName =
                fieldTranslations[error.path[0]] || error.path[0];
              const messageTranslations = {
                "This attribute must be unique":
                  "Cet attribut doit être unique",
                "This field is required": "Ce champ est obligatoire",
                "Invalid format": "Format invalide",
              };

              const translatedMessage =
                messageTranslations[error.message] || error.message;
              toast.error(`${fieldName}: ${translatedMessage}`);
            });
          }

          return;
        }
        response?.data?.data && toast.success("Redevable ajouté avec succès");

        if (response?.error) {
          console.error("Erreur lors de l'envoi :", response.error);
          toast.error("Erreur lors de l'envoi");

          // Vérifier que la structure d'erreur existe avant d'y accéder
          if (response?.error?.data?.error?.details?.errors) {
            response.error.data.error.details.errors.forEach((error) => {
              const fieldTranslations = {
                nina: "NINA",
                rccm: "RCCM",
                email: "Email",
                phone: "Téléphone",
              };

              const fieldName =
                fieldTranslations[error.path[0]] || error.path[0];
              const messageTranslations = {
                "This attribute must be unique":
                  "Cet attribut doit être unique",
                "This field is required": "Ce champ est obligatoire",
                "Invalid format": "Format invalide",
              };

              const translatedMessage =
                messageTranslations[error.message] || error.message;
              toast.error(`${fieldName}: ${translatedMessage}`);
            });
          }

          return;
        }

        const currentMonth = new Date().getMonth();

        if (data?.category2 === "site_specialise") {
          // Date 20 jours avant la fin de l'année
          const endOfYear = new Date(new Date().getFullYear(), 11, 31); // 31 décembre
          const targetDate = new Date(endOfYear);
          targetDate.setDate(endOfYear.getDate() - 20); // 20 jours avant

          const formattedDate = `${targetDate.getFullYear()}-${(
            targetDate.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}-${targetDate
            .getDate()
            .toString()
            .padStart(2, "0")}`;

          await postRedevance({
            data: {
              type: +data.type,
              montant: data.montant,
              status: false,
              date: formattedDate,
              redevable: response.data.data.id,
            },
          });
          setShowForm(false);
          toast.success("Rédevances ajouté avec succès");
          getRedevables({ page: 1, size: 50 });
        } else if (data?.category2 === "radio_television") {
          // Date 20 jours avant la fin de l'année
          const endOfYear = new Date(new Date().getFullYear(), 11, 31); // 31 décembre
          const targetDate = new Date(endOfYear);
          targetDate.setDate(endOfYear.getDate() - 20); // 20 jours avant

          const formattedDate = `${targetDate.getFullYear()}-${(
            targetDate.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}-${targetDate
            .getDate()
            .toString()
            .padStart(2, "0")}`;

          await postRedevance({
            data: {
              type: +data.type,
              montant: data.montant,
              status: false,
              date: formattedDate,
              redevable: response.data.data.id,
            },
          });
          setShowForm(false);
          toast.success("Rédevances ajouté avec succès");
          getRedevables({ page: 1, size: 50 });
        } else {
          if (data.type !== 11) {
            for (let i = 0; i < 12; i++) {
              const formattedDate = `${new Date().getFullYear()}-${(i + 1)
                .toString()
                .padStart(2, "0")}-01`;

              await postRedevance({
                data: {
                  type: +data.type,
                  montant: data.montant,
                  status: false,
                  date: formattedDate,
                  redevable: response.data.data.id,
                },
              });
            }
          }
          setShowForm(false);
          toast.success("Rédevances ajouté avec succès");
          getRedevables({ page: 1, size: 50 });
        }

        setShowForm(false);
        toast.success("Rédevances ajouté avec succès");
        getRedevables({ page: 1, size: 50 });
      } else {
        toast.error("Veuillez choisir un type de redevable");
        return;
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
      toast.error("Erreur lors de l'envoi");
    }
  };

  useEffect(() => {
    fetchDropdownData();
    getFields(3);
    getRedevables({ page: 1, size: 50 });
  }, [fetchDropdownData, getFields, getRedevables]);

  return (
    <div className="m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl">
      <ToastContainer />
      <Header category="Page" title="Redevables" />
      <div className="flex justify-around items-center">
        {fields && (
          <Modal
            toSelect={typeData} // Passer typeData correctement
            toSelect2={bureau}
            showForm={showForm}
            send={send}
            setShowForm={setShowForm}
            fields={fields} // Passer les champs mis à jour
            setRedevances={setRedevances}
            selectedData={selected?.attributes}
          />
        )}
      </div>
      <div className="flex flex-wrap lg:flex-nowrap justify-center">
        <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg h-44 rounded-xl w-full lg:w-80 p-8 pt-9 m-3 bg-hero-pattern bg-no-repeat bg-cover bg-center">
          <div className="flex justify-between items-center">
            <div>
              <p className="font-bold text-gray-400">NB redevables</p>
              <p className="text-xl">{data?.meta?.pagination?.total ?? 0}</p>
            </div>
          </div>
          {/* <div className="mt-6">
            <Button
              color="white"
              bgColor={"#386b9f"}
              text="Télécharger"
              borderRadius="10px"
              size="md"
            />
          </div> */}
        </div>
        <div className="flex w-44 justify-center items-center">
          <button
            onClick={() => {
              setShowForm(true);
              setSelected(null);
            }}
            className="text-white w-full text-3xl flex bg-primary hover:bg-primary/70 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            type="button">
            <IoIosPersonAdd />
            <p className="text-base"> Ajouter un redevable </p>
          </button>
        </div>
      </div>

      <div className="w-full flex justify-between mb-4 bg-slate-200 p-2 rounded-2xl shadow-md space-x-3 py-2">
        <div className="flex items-center space-x-2">
          <label htmlFor="nombre" className="text-gray-600 font-semibold">
            Nombre d'éléments:
          </label>

          <select
            onClick={(e) => getRedevablesByElementsNb(e?.target?.value)}
            className="bg-slate-100 w-24 text-center text-slate-500 font-bold rounded-2xl p-2"
            name="nombre"
            id="nombre">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
            <option value="1000">tout</option>
          </select>

          <div className="relative text-gray-600">
            <input
              onChange={search}
              value={searchTerm}
              type="search"
              name="search"
              placeholder="Recherche"
              className="bg-white h-10 px-5 pr-10 rounded-full text-sm focus:outline-none"
            />
            <button type="submit" className="absolute right-0 top-0 mt-3 mr-4">
              <svg
                className="h-4 w-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 56.966 56.966"
                style={{ enableBackground: "new 0 0 56.966 56.966" }}
                xmlSpace="preserve"
                width="512px"
                height="512px">
                <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
              </svg>
            </button>
          </div>
        </div>

        <div>
          <span
            onClick={() => setFilter("today")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Aujourd'hui
          </span>
          <span
            onClick={() => setFilter("this_week")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Cette semaine
          </span>
          <span
            onClick={() => setFilter("this_month")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Ce mois
          </span>
          <span
            onClick={() => setFilter("this_year")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Cette année
          </span>
        </div>
      </div>
      <GridComponent
        dataSource={searchData && searchTerm?.length > 2 ? searchData?.data :  data?.data}
        id="Grid"
        height={520} // hauteur fixe
        width="100%" // largeur stable
        rowHeight={38} // hauteur de ligne uniforme (optionnel)
        className="p-4 rounded-2xl  shadow-xl overflow-hidden overflow-y-scroll h-full"
        allowExcelExport={true}
        toolbarClick={toolbarClick}
        allowFiltering={true}
        allowSorting
        toolbar={["ExcelExport"]}
        pageSettings={{ pageSize: 50 }}
        excelExportComplete={excelExportComplete}
        excelQueryCellInfo={excelQueryCellInfo}
        ref={(g) => (grid = g)}>
        <ColumnsDirective>
          {employeesGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} className="font-semibold" />
          ))}
          <ColumnDirective
            headerText="Action"
            width="100"
            field="action"
            template={(item) => (
              <div className="flex justify-center items-center space-x-4">
                <button
                  onClick={() => handleShowUsager(item)}
                  className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
                  <FaEye />
                </button>
                <button
                  onClick={() => handleShowModal(item)}
                  className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
                  <BsPencilSquare />
                </button>
                <button
                  onClick={() => handleDelele(item)}
                  className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
                  <BsTrash2 />
                </button>
              </div>
            )}
          />
        </ColumnsDirective>
        <Inject services={[Page, Edit, Toolbar, ExcelExport, Sort, Filter]} />
      </GridComponent>

      <div className="w-full flex justify-end mt-4">
        <Pagination next={next} prev={prev} />
      </div>

      <Modal1 title="Details usager" setShow={setShowUsager} show={showUsager}>
        <UsagersCard item={selected} analyse={redevanceAnalyseData} />
      </Modal1>
      <Modal1
        title="Vous vous supprimer ce usagers"
        setShow={setDeleteUsager}
        show={deleteUsager}>
        <div>
          <div className="flex space-x-6 justify-center items-center mb-6">
            <div>
              <p className="font-bold"> Nom </p>
              <p className=""> {selected?.name} </p>
            </div>
            <div className="text-center">
              <p className="font-bold"> RCCM </p>

              <p className=""> {selected?.rccm} </p>
            </div>
          </div>
          <div className="flex space-x-6 justify-center items-center mb-6">
            <div>
              <p className="font-bold"> Téléphone </p>
              <p className=""> {selected?.phone} </p>
            </div>
            <div className="text-center">
              <p className="font-bold"> Quartier </p>

              <p className=""> {selected?.quartier?.data?.attributes.name} </p>
            </div>
          </div>
          <div className="w-full flex justify-end space-x-3 py-2">
            <button
              onClick={() => {
                setDeleteUsager(false);
              }}
              className="bg-red-400 px-4 w-44 text-center py-1 rounded-full hover:bg-red-200 shadow-md cursor-pointer font-semibold">
              Annuler
            </button>
            <button
              onClick={handleDeleteAction}
              className="bg-green-400 px-4 w-44 text-center py-1 rounded-full hover:bg-green-200 shadow-md cursor-pointer font-semibold">
              Confirmer
            </button>
          </div>
        </div>
      </Modal1>
    </div>
  );
};

export default Employees;
